document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.slider-content');
  const leftBtn = document.getElementById('leftBtn');
  const rightBtn = document.getElementById('rightBtn');
  const scrollAmount = slider.clientWidth / 2; // Scroll by half the width of the visible area

  leftBtn.addEventListener('click', () => {
    slider.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });

  rightBtn.addEventListener('click', () => {
    slider.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });
});